import { ApiError } from './error';

/**
 * 要求した `(台帳, scope)` が組織設定で無効化されている 403（code: `DATA_SCOPE_DISABLED`）。
 *
 * 権限スコープ未保有の 403（`ForbiddenApiError`）と違い、ユーザー自身の権限は足りているため
 * `accessibles` は返らず、代替導線ダイアログも出さない。BE の `displayMessages` をそのまま
 * 見せる。
 *
 * `ApiError` を継承する理由: 4xx のリトライ抑止・グローバルエラーダイアログ・表示メッセージの
 * 解決はいずれも `instanceof ApiError` で分岐している。この系統の 403 を素の `Error` として
 * 定義すると、それらの分岐から外れて 500 相当の扱いに化ける（DC-8903 の発生機序）。
 *
 * 型を分ける利点は、`handleForbidden` の分岐が汎用 403 のフォールバックと式レベルで同一に
 * ならないこと（同一だと将来まとめられて区別が失われる）と、ボディのパースに失敗しても
 * 分類が残ること（`ApiError` はスキーマ不一致のボディで `statusCode` しか救出できず `code`
 * を失うが、本クラスは `code` を読めた時点で確定する）。
 */
export class DataScopeDisabledApiError extends ApiError {
  constructor(res: unknown) {
    super(res);
    this.name = 'DataScopeDisabledApiError';
    Object.setPrototypeOf(this, DataScopeDisabledApiError.prototype);
  }
}